import { CdpEuiccListParameters, CdpEuiccListResponse, CdpEuiccListResult } from "../app/shared/models/layout/cdp/euicc/list/CdpEuiccList";

export function response(params: CdpEuiccListParameters): CdpEuiccListResponse {

    let result = [ ...data ];
    if (params.sort) {
        let order = params.sort.charAt(0);
        let sort = params.sort.slice(1);
        result = result.sort((a, b) => order === "+" ? a[sort].localeCompare(b[sort]) : b[sort].localeCompare(a[sort]));
    }

    let response: CdpEuiccListResponse = {
        cmd: {
            success: true,
            params: {
                count: result.length,
                result: result.slice(params.offset, params.offset + params.limit)
            }
        }
    }
    return response;
}

const data: CdpEuiccListResult[] =
    [
        {
            "id": "62e7a262907c9c5f84586276",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89040024000002593200010000007090",
            "sgpType": "02",
            "fallbackIccid": "89562008019000000286",
            "profiles": [
                {
                    "iccid": "89562008019000000286"
                }
            ],
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-01T09:52:34.019Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-01T09:52:34.019Z"
        },
        {
            "id": "62f5030bfe2a133be4b4f00d",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89040024000002593200010000006023",
            "sgpType": "02",
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-11T13:24:27.096Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-11T13:24:27.096Z"
        },
        {
            "id": "62f517d21c5bd71c93b2ad06",
            "orgId": "5ea0823b1c5bd764010b9e0c",
            "sharerOrgId": "5ea0823b1c5bd764010b9e0c",
            "ownerOrgId": "5ea0823b1c5bd764010b9e0c",
            "isShared": false,
            "permission": "rw",
            "eid": "89040024000002593200010000006605",
            "sgpType": "02",
            "fallbackIccid": "89562008019000000245",
            "profiles": [
                {
                    "iccid": "89562008019000000245"
                }
            ],
            "createdBy": "SYSTEM",
            "createdOn": "2022-08-11T14:53:06.733Z",
            "updatedBy": "SYSTEM",
            "updatedOn": "2022-08-11T14:53:06.733Z"
        }
    ];
